import { type Command } from '@telespot/core';

/**
 * @group Protocols
 * @category Payloads
 */
export interface DeprecateAlgorithmDetails {
  /**
   * The id of the algorithm to deprecate.
   */
  algorithmId: string;

  /**
   * Whether or not to deprecate the algorithm
   * If not provided, the algorithm will be deprecated, assuming true.
   * If false, the algorithm will be undeprecated.
   */
  deprecate?: boolean;
}

/**
 * @group Protocols
 * @category Tokens
 */
export const DEPRECATE_ALGORITHM = 'protocols:deprecateAlgorithm';

export class DeprecateAlgorithm implements Command<typeof DEPRECATE_ALGORITHM, DeprecateAlgorithmDetails> {
  public readonly name = DEPRECATE_ALGORITHM;
  constructor(public readonly details: DeprecateAlgorithmDetails) {}
}
